import {createSelector, MemoizedSelector} from '@ngrx/store';
import {Adjunto, adjuntosAdapter, AdjuntosState} from './adjuntos.state';

import {FeaturesState, selectFeatures} from '../../../features.state';

export const getError = (state: AdjuntosState): any => state.error;

export const getIsLoading = (state: AdjuntosState): boolean =>
  state.isLoading;

export const selectAdjuntosState = createSelector(
  selectFeatures,
  (state: FeaturesState) => state.adjuntos
);

export const selectAllAdjunto: (state: object) =>
  Adjunto[] = adjuntosAdapter.getSelectors(selectAdjuntosState).selectAll;

export const selectAdjuntosError: MemoizedSelector<object, any> = createSelector(
  selectAdjuntosState,
  getError
);

export const selectAdjuntosIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectAdjuntosState,
  getIsLoading
);
